import { runAudioStore } from './audioIdb';

const PLAYLIST_STORE = 'playlists';
const CATEGORY_STORE = 'browseCategories';
const GENRE_STATION_STORE = 'genreStations';

async function clearStore(storeName) {
  await runAudioStore(storeName, 'readwrite', (store) => {
    store.clear();
  });
}

async function putRows(storeName, rows) {
  if (!rows?.length) return;
  await runAudioStore(storeName, 'readwrite', (store) => {
    rows.forEach((row) => {
      if (row?.id) store.put(row);
    });
  });
}

export async function mirrorPlaylistsToLocal(rows) {
  await clearStore(PLAYLIST_STORE);
  await putRows(PLAYLIST_STORE, rows);
}

export async function mirrorCategoriesToLocal(rows) {
  await clearStore(CATEGORY_STORE);
  await putRows(CATEGORY_STORE, rows);
}

export async function mirrorGenreStationsToLocal(rows) {
  await clearStore(GENRE_STATION_STORE);
  await putRows(GENRE_STATION_STORE, rows);
}

export async function mirrorCloudLibraryToLocal({ playlists = [], categories = [], genreStations = [] }) {
  await mirrorPlaylistsToLocal(playlists);
  await mirrorCategoriesToLocal(categories);
  await mirrorGenreStationsToLocal(genreStations);
}

export async function mirrorPlaylistToLocal(entry) {
  if (!entry?.id) return;
  await runAudioStore(PLAYLIST_STORE, 'readwrite', (store) => store.put(entry));
}

export async function mirrorCategoryToLocal(entry) {
  if (!entry?.id) return;
  await runAudioStore(CATEGORY_STORE, 'readwrite', (store) => store.put(entry));
}

export async function mirrorGenreStationToLocal(entry) {
  if (!entry?.id) return;
  await runAudioStore(GENRE_STATION_STORE, 'readwrite', (store) => store.put(entry));
}

export async function deleteLocalPlaylist(id) {
  if (!id) return;
  await runAudioStore(PLAYLIST_STORE, 'readwrite', (store) => store.delete(String(id)));
}

export async function deleteLocalCategory(id) {
  if (!id) return;
  await runAudioStore(CATEGORY_STORE, 'readwrite', (store) => store.delete(String(id)));
}

export async function deleteLocalGenreStation(id) {
  if (!id) return;
  await runAudioStore(GENRE_STATION_STORE, 'readwrite', (store) => store.delete(String(id)));
}
